<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup change company
 * @created at      :   2022/07/28
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import { mapMutations, mapState } from 'vuex';
import moment from 'moment';
import repository from '@/utils/repository';
import store from '@/store';
import helpers from '@/utils/helpers';
import _ from 'lodash';

import PopupNewCompany from '@/views/popup/newCompany';

/**
 * Import template
 */
import template from './template.html';
import './style.scss';

/**
 * Define component chat for show page chat
 */
var PopupChangeUser = {
    template: template,
    props: {
        modelValue: Boolean,
        onSelected: Function
    },
    emits: ['update:modelValue'],
    components: {
        PopupNewCompany
    },
    data() {
        return {
            listAttr: [],
            companies: [],
            paging: {},
            showAddCompany: false,
            condition: {
                search: '',
                attrId: '0'
            }
        };
    },
    computed: {
        ...mapState('app', ['user']),
        showModal: {
            get() {
                return this.modelValue;
            },
            set() {}
        },
        username() {
            if (
                this.user.switchUser &&
                this.user.switchUser.氏名 &&
                this.user.switchUser.氏名 != this.user.氏名
            ) {
                return this.user.switchUser.氏名;
            }
            return this.user.氏名;
        }
    },
    mounted() {
        setTimeout(() => {
            this.$refs.inputSearch?.focus();
        }, 500);
    },
    methods: {
        ...mapMutations('app', ['hideHeaderError']),
        close() {
            this.$emit('update:modelValue', false);
            this.hideHeaderError();
        },
        onShow() {
            this.hideHeaderError();
            this.initData();
            this.searchCompanies();
        },
        onHide() {
            this.condition = {
                search: '',
                attrId: '0'
            };
            this.companies = [];
            this.paging = {};
        },
        initData() {
            repository.get(`/common/companies/data/init`).then((res) => {
                const { data } = res;
                if (data.Code === 200) {
                    this.listAttr = _.map(data.Data.登録属性, (item) => {
                        return {
                            code: item.コード,
                            name: item.名称
                        };
                    });
                } else {
                    this.listAttr = [];
                }
            });
        },
        searchCompanies(page) {
            this.paging.page = page ?? 1;
            repository
                .get(`/common/companies`, {
                    params: {
                        p002: this.condition.search,
                        p003: this.condition.attrId,
                        p004: this.paging.page ?? 1
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        this.companies = data.Data.companies;
                        this.paging = data.Data.paging;
                    } else {
                        this.companies = [];
                        this.paging = {};
                    }
                });
        },
        exportCsv() {
            repository
                .get(`/common/companies/export/csv`, {
                    params: {
                        p002: this.condition.search,
                        p003: this.condition.attrId
                    }
                })
                .then((res) => {
                    const { data } = res;
                    if (data.Code === 200 && data.Data) {
                        const anchor = document.createElement('a');
                        anchor.href = `${process.env.VUE_APP_FILE_DOMAIN}?url=${
                            data.Data['url']
                        }&action=D&filename=会社一覧_${moment().format(
                            'YYYYMMDDHHmmss'
                        )}.csv&token=${sessionStorage.getItem('token')}`;
                        anchor.click();
                    }
                });
        },
        selectRow(item) {
            let switchUser = sessionStorage.getItem('switchUser');
            // if (!switchUser) {
            //     switchUser = {};
            // } else {
            //     // eslint-disable-next-line no-undef
            //     switchUser = JSON.parse(Base64.decode(switchUser));
            // }
            switchUser = {};
            switchUser.契約会社コード = item.契約会社コード;
            switchUser.契約会社名 = item.会社名;
            switchUser.契約会社略称 = item.会社名;
            switchUser.契約会社属性 = item.登録属性;
            this.user.switchUser = switchUser;
            sessionStorage.setItem(
                'switchUser',
                // eslint-disable-next-line no-undef
                Base64.encode(JSON.stringify(switchUser))
            );
            store.dispatch('app/getAppState', null, { root: true });
            if (this.onSelected) {
                this.onSelected(item);
            }
            this.close();
            if (item.契約会社コード == this.user.契約会社コード) {
                this.$router.push({
                    name: 'Gs0510v'
                });
            } else {
                this.$router.push({
                    name: 'Cm0020i',
                    query: {
                        p: helpers.encodeParams({
                            id: item.契約会社コード
                        })
                    }
                });
            }
        },
        resetCompany() {
            this.user.switchUser = null;
            sessionStorage.removeItem('switchUser');
            this.close();
            store.dispatch('app/getAppState', null, { root: true });
            this.$router.push({
                name: 'Gs0510v'
            });
        }
    }
};
export default PopupChangeUser;
</script>
